import React from 'react';

import { FullScreenModalDialog } from '@atlaskit/modal-dialog/full-screen';

import { ModalCustomUIRendererHeader, type ModalHeaderProps } from './ModalCustomUIRendererHeader';

type FullscreenModalProps = {
	closeProps: {
		onClose: () => Promise<void>;
		onCloseComplete?: () => void;
		shouldCloseOnEscapePress?: boolean;
	};
	headerProps: ModalHeaderProps;
	isBridgeModal: boolean;
	isMacroExtension: boolean;
	modalContent: React.JSX.Element;
};

export const FullscreenModal = ({
	closeProps,
	modalContent,
	headerProps,
}: FullscreenModalProps): React.JSX.Element => {
	return (
		<FullScreenModalDialog {...closeProps} testId="custom-ui-fullscreen-modal-dialog">
			{/** Must restrict to macros and bridge modal, as it would be a breaking change in byline to render this header */}
			{headerProps.isMacroExtension || headerProps.isBridgeModal ? (
				<ModalCustomUIRendererHeader {...headerProps} />
			) : null}
			{modalContent}
		</FullScreenModalDialog>
	);
};
